import { InternalTransfersExport } from 'commons/types/DTO/bank'
import { Request } from 'commons/utils/request/request'

export const processInternalTransferExport = (id: number) =>
  Request.put<InternalTransfersExport>(Request.urls.bank.internalTransfersExportProcess, { id })

export const cancelInternalTransfer = (id: number) => Request.put(Request.urls.bank.internalTransferCancel, { id })
